import ol = require("ol");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

class Handler extends Base<{}> {

    public static about = `

Proxy for the openlayers [MousePosition](http://openlayers.org/en/latest/apidoc/ol.control.MousePosition.html) control.

`;

    public static options = {
        "fractions": {
            about: "Number of decimal places",
            default: "4"
        },
        "projection": {
            about: "spatial reference system",
            default: "EPSG:4326"
        },
        "class-name": {
            about: "class name to assign to the MousePosition control",
            default: "xy-position"
        },
        "default-markup": {
            "about": "Markup to use when the control doesn't have a position to report",
            "default": "&nbsp;",
        },
    }

    private forceControl(map: ol.Map) {
        let c = this.mediator.model.get("map-hover-handler");
        if (!c) {
            c = this.createControl();
            map.addControl(c);
            this.mediator.model.set("map-hover-handler", c);
        }
        return c;
    }

    private createControl() {
        let config = this.asOptions(Handler.options);
        let projection = config.projection;
        let className = config['class-name'];
        let undefinedHTML = config['default-markup'];
        let fractions = config.fractions;

        let coordinateFormat = ol.coordinate.createStringXY(parseInt(fractions));

        let c = new ol.control.MousePosition({
            coordinateFormat: coordinateFormat,
            projection: projection,
            // comment the following two lines to have the mouse position
            // be placed within the map.
            className: className,
            //target: document.getElementById('mouse-position'),
            undefinedHTML: undefinedHTML
        });

        return c;
    }

    execute(args = this.args) {
        this.mediator.mapViewMap(map => {
            let c = this.forceControl(map);
            this.trigger({ control: c });
        });
    }

}

export = Handler;  